/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliStudentDto } from '../../models/amoxcalli-student-dto';

export interface ApiStudentsIdGet$Plain$Params {
  id: string;
}

export function apiStudentsIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiStudentsIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliStudentDto>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliStudentDto>;
    })
  );
}

apiStudentsIdGet$Plain.PATH = '/api/students/{id}';
